module.exports = __webpack_public_path__ + "dfe764fe6763836f81f41e9fca528338.svg";